import React from 'react'
import { TawreedDropdownProps, TawreedMenuDropdown } from '../../../../common/components/form'

export const NationalityDropdown: React.FC<TawreedDropdownProps> = (props) => {

    return <TawreedMenuDropdown {...props} menu={"nationality"} />
}
